<template>
  <div>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="submitBtnLoading"
    >
      <div class="bg-white note-wrapper">
        <div class="d-flex justify-content-between">
          <span class="mb-1"> <b> {{ noteData.addedBy }} </b> </span>
          <b-button
            v-if="($can('write', 'driver-notes') || $can('write', 'user-notes'))"
            class="btn-icon rounded-circle text-black"
            variant="flat"
            @click="showEditSection= !showEditSection"
          >
            <feather-icon
              :icon="showEditSection ? 'XCircleIcon' : 'EditIcon'"
            />
          </b-button>
        </div>
        <p
          v-if="!showEditSection"
          class="ml-1"
        >
          {{ note.category }}
        </p>
        <p
          v-if="!showEditSection"
          class="ml-1"
        >
          {{ note.note }}
          {{ note.status === 'NEW' ? '' : '(edited)' }}
        </p>
        <div
          v-else
          class="d-flex flex-column"
        >
          <b-form-group
            label="Category"
            label-for="category"
          >
            <v-select
              id="category"
              v-model="noteData.category"
              :options="notesCategories"
            />
          </b-form-group>
          <b-form-textarea
            id="editTask"
            v-model="noteData.note"
            class="mr-1"
            name="editNote"
            rows="4"
            cols="50"
          />
          <b-button
            class="mt-1"
            variant="primary"
            @click="editNote"
          >
            Edit
          </b-button>
        </div>
        <p class="ml-1 mt-1">
          Created at: {{ noteData.createdAt | formatDate }}
        </p>
        <p
          v-if="noteData.updatedAt"
          class="ml-1 mt-1"
        >
          Edited at: {{ noteData.updatedAt | formatDate }}
        </p>
        <p
          v-if="noteData.updatedBy"
          class="ml-1 mt-1"
        >
          Edited by: {{ noteData.updatedBy }}
        </p>
      </div>
    </b-overlay>
  </div>
</template>
<script>
import {
  BButton, BFormTextarea, BOverlay, BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import useEditNote from './hooks/useEditNote'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import notesStore from '@/views/driver-user-shared/notes/store'

export default {
  components: {
    BButton,
    BFormTextarea,
    BFormGroup,
    BOverlay,
    vSelect,
  },
  props: {
    note: {
      type: Object,
      default: undefined,
    },
    notableType: {
      type: String,
      default: '',
    },
  },
  setup(props, ctx) {
    useRegisterStoreModule('notes', notesStore)
    return {
      ...useEditNote(props, ctx),
    }
  },
}
</script>

<style scoped>
.note-wrapper{
  padding: 10px 10px 5px;
  color: black;
  border: 4px solid #CE224D;
  border-radius: 5px;
  margin-bottom: 20px;
}
</style>
